import React, { useEffect, useState, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button } from '../ui/Button';
import { MenuIcon, XIcon, PalmtreeIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const comebackPrograms = [{
    name: 'Boxing & Fitness Bootcamp',
    path: '/comeback-programs?program=boxing-bootcamp'
  }, {
    name: 'Singles Social',
    path: '/comeback-programs?program=singles-social'
  }, {
    name: 'Couples Reset & Vow-Renewal',
    path: '/comeback-programs?program=couples-reset'
  }, {
    name: 'Friends Reunion Weekend',
    path: '/comeback-programs?program=friends-reunion'
  }, {
    name: 'Family Beach & Kids Leadership Camp',
    path: '/comeback-programs?program=family-beach'
  }, {
    name: 'Wellness Reset: Yoga & Breathwork',
    path: '/comeback-programs?program=wellness-reset'
  }, {
    name: 'Golf & Beach Games Weekend',
    path: '/comeback-programs?program=golf-beach'
  }, {
    name: 'Family Adventure: Cenotes & Reefs',
    path: '/comeback-programs?program=family-adventure'
  }, {
    name: 'Women in Leadership & Wellness',
    path: '/comeback-programs?program=women-leadership'
  }, {
    name: 'Desta Community Offsite Weekend',
    path: '/comeback-programs?program=community-offsite'
  }, {
    name: 'Yacht Social & Sunset Jams',
    path: '/comeback-programs?program=yacht-social'
  }, {
    name: 'Kids Sports & Leadership Camp',
    path: '/comeback-programs?program=kids-sports'
  }, {
    name: 'Startup Bootcamp',
    path: '/comeback-programs?program=startup-bootcamp'
  }, {
    name: 'Founders & Investors Circle',
    path: '/comeback-programs?program=founders-investors'
  }];
  const navLinks = [{
    name: 'Solutions',
    path: '/packages'
  }, {
    name: 'Sample Agenda',
    path: '/agenda'
  }, {
    name: 'Venues',
    path: '/venues'
  }, {
    name: 'Comeback Programs',
    path: '/comeback-programs',
    dropdown: true,
    items: comebackPrograms
  }, {
    name: 'Trainer Partner Program',
    path: '/trainer-partner-program'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-106">
      <div className="container mx-auto px-4 md:px-6" data-id="element-107">
        <div className="flex items-center justify-between" data-id="element-108">
          <Link to="/" className="flex items-center" data-id="element-109">
            <PalmtreeIcon className="h-6 w-6 mr-2 text-[#0099A1]" data-id="element-110" />
            <span className="text-2xl font-bold text-[#0099A1]" data-id="element-111">
              Desta<span className="text-[#FF6B65]" data-id="element-112">Meet</span>
            </span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-4" data-id="element-113">
            {navLinks.map((link, index) => link.dropdown ? <div key={index} className="relative" ref={dropdownRef} data-id="element-114">
                  <button className={`px-3 py-2 text-sm uppercase tracking-wider font-medium rounded-md transition-colors flex items-center text-[#374047] hover:text-[#0099A1]`} onClick={() => setDropdownOpen(!dropdownOpen)} data-id="element-115">
                    {link.name}
                    {dropdownOpen ? <ChevronUpIcon className="h-4 w-4 ml-1" data-id="element-116" /> : <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-117" />}
                  </button>
                  {dropdownOpen && <div className="absolute left-0 mt-2 w-64 bg-white rounded-md shadow-lg py-1 z-50 max-h-[80vh] overflow-y-auto" data-id="element-118">
                      <Link to={link.path} className="block px-4 py-2 text-sm text-[#374047] hover:bg-[#0099A1]/10 hover:text-[#0099A1] font-medium" onClick={() => setDropdownOpen(false)} data-id="element-119">
                        View All Programs
                      </Link>
                      <div className="border-t border-gray-100 my-1" data-id="element-120"></div>
                      {link.items.map((item, i) => <Link key={i} to={item.path} className="block px-4 py-2 text-sm text-[#374047] hover:bg-[#0099A1]/10 hover:text-[#0099A1]" onClick={() => setDropdownOpen(false)} data-id="element-121">
                          {item.name}
                        </Link>)}
                    </div>}
                </div> : <NavLink key={index} to={link.path} className={({
            isActive
          }) => `px-3 py-2 text-sm uppercase tracking-wider font-medium rounded-md transition-colors ${isActive ? 'text-[#0099A1]' : 'text-[#374047] hover:text-[#0099A1]'}`} data-id="element-122">
                  {link.name}
                </NavLink>)}
            <Button variant="primary" className="ml-4" to="/contact" data-id="element-123">
              Book Discovery Call
            </Button>
          </nav>
          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 rounded-md text-[#374047]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-124">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-125" /> : <MenuIcon className="h-6 w-6" data-id="element-126" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMobileMenuOpen && <nav className="lg:hidden mt-4 pb-4" data-id="element-127">
            <div className="flex flex-col space-y-2" data-id="element-128">
              {navLinks.map((link, index) => link.dropdown ? <div key={index} className="space-y-1" data-id="element-129">
                    <Link to={link.path} className={`px-3 py-2 text-sm uppercase tracking-wider font-medium rounded-md transition-colors bg-[#0099A1]/10 text-[#0099A1]`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-130">
                      {link.name} - All Programs
                    </Link>
                    {link.items.map((item, i) => <Link key={i} to={item.path} className="px-3 py-2 ml-4 text-xs uppercase tracking-wider font-medium rounded-md transition-colors text-[#374047] hover:bg-gray-100 block" onClick={() => setIsMobileMenuOpen(false)} data-id="element-131">
                        {item.name}
                      </Link>)}
                  </div> : <NavLink key={index} to={link.path} className={({
            isActive
          }) => `px-3 py-2 text-sm uppercase tracking-wider font-medium rounded-md transition-colors ${isActive ? 'bg-[#0099A1]/10 text-[#0099A1]' : 'text-[#374047] hover:bg-gray-100'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-132">
                    {link.name}
                  </NavLink>)}
              <Button variant="primary" className="mt-2" to="/contact" onClick={() => setIsMobileMenuOpen(false)} data-id="element-133">
                Book Discovery Call
              </Button>
            </div>
          </nav>}
      </div>
    </header>;
}